import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useInView } from "react-intersection-observer";

// icons
import icon01 from "../../../images/icons/rev_diab_icn.png";
import icon02 from "../../../images/icons/wght_loss_icn.png";
import icon03 from "../../../images/icons/high_med_icn.png";
import icon04 from "../../../images/icons/hypertension_icn.png";
import icon05 from "../../../images/icons/fatty_liver_icn.png";
import icon06 from "../../../images/icons/cholestrol_icn.png";

// css
import * as styles from "./HealthyMetabolism.module.css";

const HealthyMetabolismComponent = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  // Cards data
  const cardsData = [
    {
      id: 1,
      icon: icon01,
      percentage: "76.5%",
      description: "Reversed their diabetes",
      alt: "Reversed diabetes icon",
    },
    {
      id: 2,
      icon: icon02,
      percentage: "6.5 KG",
      description: "Average weight loss",
      alt: "Weight loss icon",
    },
    {
      id: 3,
      icon: icon03,
      percentage: "72%",
      description: "Reduction or elimination of high-cost medications",
      alt: "Reduced medications icon",
    },
    {
      id: 4,
      icon: icon04,
      percentage: "69%",
      description: "Hypertension Normalized",
      alt: "Hypertension icon",
    },
    {
      id: 5,
      icon: icon05,
      percentage: "83.2%",
      description: "Reduction in fatty liver",
      alt: "Fatty liver icon",
    },
    {
      id: 6,
      icon: icon06,
      percentage: "77%",
      description: "Normalized cholesterol levels",
      alt: "Cholesterol icon",
    },
  ];

  return (
    <section className={styles.healthyMetabolismWrapper}>
      {/* Content Section */}
      <div
        ref={ref}
        className={`container scroll_animate ${inView && "inview"}`}
      >
        <div className="row">
          <div className="col-12">
            <div className={styles.bannerContainer}>
              <StaticImage
                src="../../../images/home/healthy_metabolism_banner.png"
                alt="The power of a healthy metabolism"
                placeholder="blurred"
                className={styles.bannerImage}
                loading="lazy"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className={styles.contentSection}>
              {/* Header */}
              <div className={styles.headerSection}>
                <h1 className={styles.mainTitle}>Real-world outcomes from</h1>
                <p className={styles.mainDescription}>2,10,000+ members</p>
              </div>

              {/* Cards Grid */}
              <div className={styles.cardsGrid}>
                {cardsData.map(card => (
                  <div key={card.id} className={styles.card}>
                    <div className={styles.cardContent}>
                      <div className={styles.iconWrapper}>
                        <img
                          src={card.icon}
                          alt={card.alt}
                          className={styles.cardIcon}
                        />
                      </div>
                      <div className={styles.textWrapper}>
                        <h3 className={styles.percentage}>{card.percentage}</h3>
                        <p className={styles.description}>{card.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HealthyMetabolismComponent;
